export enum AppraisalRelationshipStatus {
  Pending = 0,
  Active = 1,
  Rejected = 2,
  Revoked = 3
}
